import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LeafletMap from '../Components/LeafletMaps/LeafletMap';
import { useTranslation } from 'react-i18next';

const MapView = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Box sx={{ width: '100%', px: 0, py: 0 }}>
            <Box
                sx={{
                    position: 'relative',
                    height: { xs: 'calc(100vh - 250px)', md: 'calc(100vh - 215px)' },
                    minHeight: { xs: 440, md: 520 },
                    overflow: 'hidden',
                    background: '#fff'
                }}
            >
                <Button
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('/public/clubs')}
                    sx={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        zIndex: 20,
                        borderRadius: 1,
                        background: '#fff',
                        color: '#1a73e8',
                        border: '1px solid #d8e6f8',
                        boxShadow: '0 2px 10px rgba(15, 23, 42, 0.16)',
                        textTransform: 'none',
                        fontWeight: 800,
                        '&:hover': {
                            background: '#f5faff'
                        }
                    }}
                >
                    {t('BackToList')}
                </Button>
                <LeafletMap />
            </Box>
        </Box>
    );
};

export default MapView;
